import { compact, find, flatMap, map } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";

export function useContextualWorkspaceAccounts() {
  const workspace = useCurrentWorkspace();
  const project = useCurrentProject();
  return !!workspace && !!project
    ? flatMap(
        map(workspace.socialAccounts, (accountIds, platform) => {
          return compact(
            map(accountIds, (id) => {
              return find(project.socialAccounts[platform], { id });
            })
          );
        })
      )
    : [];
}
